import React from "react";
import {connect} from "react-redux";
import {Alert, Button, Progress, Row, Typography} from "antd";
import {ClockCircleOutlined, ReloadOutlined} from '@ant-design/icons';
import {IAppState} from "../../../redux/store";
import LocaleText from "../../app/settings/dictionary/LocaleText";
import {startLoading} from "../../../redux/actions/Setup";


interface IProps {
    forceReload?: boolean
    startLoading?: () => void
}

interface IState {
    forceReloadCountDown: number
    forceReloadInterval: number
}

class ForceReloadAlert extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            forceReloadCountDown: 60,
            forceReloadInterval: 0
        }
    }

    _isMounted = false;

    componentWillUnmount() {
        clearInterval(this.state.forceReloadInterval);
        this._isMounted = false
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        if (this.props.forceReload === true && prevProps.forceReload !== this.props.forceReload) {
            this.startImport()
        }
    }

    timer = () => {
        this.setState(prevState => ({forceReloadCountDown: Math.max(prevState.forceReloadCountDown - 1, 0)}), () => this.state.forceReloadCountDown === 0 && this.reload());
    }

    startImport = () => {
        const interval = setInterval(this.timer, 1000) as unknown as number;
        this.setState({forceReloadInterval: interval});
    }

    postponeForceReload = () => {
        this.setState(prevState => ({forceReloadCountDown: Math.max(prevState.forceReloadCountDown + 120, 0)}));
    }

    reload = () => {
        this.props.startLoading?.()
        window.location.href = window.location.pathname + "?" + new Date().getTime();
    }


    render() {
        const {
            forceReload
        } = this.props;


        const {forceReloadCountDown} = this.state

        return forceReload ? (
            <Alert type={"info"} className={'centered line-break p-3'} showIcon={false} banner
                   message={<Row>
                       <Progress width={100} className={'mr-4'} format={v => forceReloadCountDown + ' s'}
                                 status={forceReloadCountDown < 20 ? 'exception' : 'normal'} type="circle"
                                 percent={(forceReloadCountDown / (forceReloadCountDown > 60 ? 180 : 60)) * 100}/>
                       <Row align={'middle'} className={'ml-3'}>
                           <div>
                               <Typography.Title level={4}>
                                   <LocaleText code={'system.header.force-reload'}
                                               fallback={'Probíhá důležitá aktualizace. Stránka se za #sec vteřin obnoví. Ujistěte se, že máte vše uloženo.'}
                                               params={{'#sec': forceReloadCountDown}}/>
                               </Typography.Title>
                               <Button className={'mr-3'} disabled={forceReloadCountDown > 60}
                                       icon={<ClockCircleOutlined/>}
                                       onClick={this.postponeForceReload}>
                                   <LocaleText code={'system.header.force-reload.postpone'}
                                               fallback={'Odložit o 2 minuty.'}/>
                               </Button>
                               <Button type={'primary'} icon={<ReloadOutlined/>} onClick={this.reload}>
                                   <LocaleText code={'system.header.force-reload.reload'} fallback={'Obnovit nyní'}/>
                               </Button>
                           </div>
                       </Row>
                   </Row>}/>) : <></>
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        forceReload: state.streamEvents.forceReload
    }
};

export default connect(mapStateToProps, {startLoading})(ForceReloadAlert);